import React, { useState } from "react";
import BackButton from "../../../../../components/common/backbutton/BackButton";
import Option from "../Option";
import NewCompanyForm from "./NewCompanyForm";
import OldCompanyForm from "./OldCompanyForm";

const ThreeMonthsReturn = () => {
  const [turnOn, setTurnOn] = useState(true);

  return (
    <div>
      <div className="px-10 lg:!px-14">
        <p className="text-primary-red my-4 font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
          3 Months Returns Form
        </p>
        <div className="flex justify-between">
          {/* <div className=" flex space-x-6 flex-col md:flex-row gap-3 text-primary-red text-base font-bold sm:text-lg">
            <td className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
              <label htmlFor="old">पहिले नै हामीसंग आवद्ध भएको कम्पनी </label>
              <input type="radio" name="radio-btn" id="old"
               onChange={()=> setTurnOn(true)}
                />
            </td>
            <td className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
              <label htmlFor="new">नयाँ कम्पनी </label>
              <input type="radio" id="new" name="radio-btn" 
              onChange={()=> setTurnOn(false)}
              />
            </td>
          </div> */}
          <Option setTurnOn={setTurnOn} />
          <p className="text-primary-red flex items-center">
            Firm No.
            <span className=" text-primary-blue"> 1234</span>
          </p>
        </div>

        {turnOn ? <OldCompanyForm /> : <NewCompanyForm />}
      </div>
    </div>
  );
};

export default ThreeMonthsReturn;
